module.exports = __webpack_public_path__ + "img/market.6f834335.svg";